import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import swal from "sweetalert";

import Sidebar from "../../elements/Sidebar";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import registercss from "../../css/registers.module.css";

import { ReactComponent as LeftIcon } from "../../assets/icons/left_arrow.svg";
import { ReactComponent as RestoreIcon } from "../../assets/icons/restore.svg";
import { ReactComponent as DeleteGreyIcon } from "../../assets/icons/delete_grey.svg";

import {
  getDeletedLeaseRegisters,
  restoreLeaseRegister,
  permanentDeleteLeaseRegister,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import ApproverLeaseModal from "../leases/ApproverLeaseModal";

export const deletedRegisterLabels = [
  {
    label: "Leases",
    value: "leases",
  },
  {
    label: "Investments",
    value: "investments",
  },
  {
    label: "Loans",
    value: "loans",
  },
  {
    label: "Receivables",
    value: "receivables",
  },
  {
    label: "Payables",
    value: "payables",
  },
  {
    label: "Sales",
    value: "sales",
  },
  {
    label: "Purchase",
    value: "purchase",
  },
];

const CreateSalesRegister = () => {
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem("user"));

  const [activeTab, setActiveTab] = useState(
    deletedRegisterLabels[0]?.value || ""
  );
  const [deletedLeaseRegisters, setDeletedLeaseRegisters] = useState([]);
  const [leaseCompanyId, setLeaseCompanyId] = useState(null);
  const [regId, setRegId] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [approverLeaseModal, setApproverLeaseModal] = useState(false);
  const [approvalFor, setApprovalFor] = useState(null);

  useEffect(() => {
    getDeletedLeases();
  }, []);

  const getDeletedLeases = () => {
    getDeletedLeaseRegisters().then((response) => {
      setDeletedLeaseRegisters(response.data.projects);
    });
  };

  const handleRestoreLeaseRegister = (registerID) => {
    swal({
      title: "Are you sure?",
      text: "Your lease will be restored",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Yes, Restore it!",
          value: true,
        },
      },
      closeOnClickOutside: false,
    })
      .then((willDelete) => {
        if (willDelete) {
          restoreLeaseRegister(registerID).then((response) => {
            swal({
              title: "Restored",
              text: "Lease Register Restored",
              icon: "success",
            });
          });
          getDeletedLeases();
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to restore lease register",
          "error"
        );
      });
  };

  const handlePermanentDeleteLeaseRegister = (registerID) => {
    swal({
      title: "Are you sure?",
      text: "This lease will be deleted permanently",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Yes, Delete it!",
          value: true,
          className: `btnRed`,
        },
      },
      closeOnClickOutside: false,
    })
      .then((willDelete) => {
        if (willDelete) {
          permanentDeleteLeaseRegister(registerID).then((response) => {
            swal({
              title: "Permanent delete",
              text: "Lease Register Deleted",
              icon: "success",
            });
          });
          getDeletedLeases();
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to delete lease register",
          "error"
        );
      });
  };

  const sendForApproval = (approverID) => {
    if (approvalFor === "restore") {
      const payload = {
        approvalStatus: "pending restore",
        approverID: approverID,
      };
      restoreLeaseRegister(regId, payload).then((response) => {
        swal({
          title: "Restore",
          text: "Approval sent for restore",
          icon: "success",
        });
        setApproverLeaseModal(false);
      });
    }
    if (approvalFor === "permanent_delete") {
      const payload = {
        approvalStatus: "pending permanent delete",
        approverID: approverID,
      };
      permanentDeleteLeaseRegister(regId, payload).then((response) => {
        swal({
          title: "Permanent Delete",
          text: "Approval sent for permanent delete",
          icon: "success",
        });
        setApproverLeaseModal(false);
      });
    }
  };

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={registercss.deletedRegisterLayout}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -100, opacity: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            className="w-100"
          >
            <div className={registercss.deletedRegisterHeader}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "15px" }}
              >
                <LeftIcon
                  onClick={() => history.push("/dashboard")}
                  style={{ cursor: "pointer" }}
                />
                <span style={{ color: "#111111", fontSize: "18px" }}>
                  Deleted Registers
                </span>
              </div>
            </div>
          </motion.div>
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            className="w-100"
          >
            <div className={registercss.headTabsContainer}>
              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={activeTab}
                  onChange={(e, val) => setActiveTab(val)}
                  sx={{
                    borderRadius: "16px 16px 0 0",
                    borderBottom: "1px solid #EAEEED",
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: 400,
                      fontSize: "16px",
                      color: "#111111",
                      backgroundColor: "transparent",
                      outline: "none",
                      opacity: 1,
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#E4F2E6",
                      color: "#205A46 !important",
                      fontWeight: "600",
                      borderBottom: "1px solid #2D8861",
                      opacity: "1",
                    },
                    "& .MuiTabs-indicator": {
                      display: "none",
                    },
                  }}
                >
                  {deletedRegisterLabels.map((label, index) => (
                    <Tab
                      key={index}
                      label={label.label}
                      value={label.value}
                      disableRipple
                      disableFocusRipple
                    />
                  ))}
                </Tabs>
                {deletedRegisterLabels.map(
                  (item) =>
                    activeTab === item.value && (
                      <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 50 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        className="w-100"
                      >
                        {item.value === "leases" ? (
                          <>
                            {deletedLeaseRegisters.map((register) => (
                              <div className={registercss.leasesDataContainer}>
                                <div className={registercss.deletedItems}>
                                  <div className={registercss.multiLabel}>
                                    <label>{register.name}</label>
                                    <span className={registercss.companyLabel}>
                                      {register?.companyData?.company_name}
                                    </span>
                                  </div>
                                  <div className={registercss.rightDataCtn}>
                                    {console.log("del register", register)}
                                    {user?.isAdmin === "Yes" && (
                                      <>
                                        <RestoreIcon
                                          onClick={() =>
                                            handleRestoreLeaseRegister(
                                              register._id
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                        <DeleteGreyIcon
                                          onClick={() =>
                                            handlePermanentDeleteLeaseRegister(
                                              register._id
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                      </>
                                    )}
                                    {user.responsibilities === "preparer" && (
                                      <>
                                        <RestoreIcon
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setApprovalFor("restore");
                                            setRegId(register._id);
                                            setLeaseCompanyId(
                                              register.companyID
                                            );
                                            setApproverLeaseModal(true);
                                          }}
                                        />
                                        <DeleteGreyIcon
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setApprovalFor("permanent_delete");
                                            setRegId(register._id);
                                            setLeaseCompanyId(
                                              register.companyID
                                            );
                                            setApproverLeaseModal(true);
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <></>
                        )}
                      </motion.div>
                    )
                )}
              </Box>
              {approverLeaseModal && regId && leaseCompanyId && (
                <ApproverLeaseModal
                  setApproverLeaseModal={setApproverLeaseModal}
                  companyId={leaseCompanyId}
                  setApproverId={setApproverId}
                  sendForApproval={sendForApproval}
                />
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default CreateSalesRegister;
